import { render, staticRenderFns } from "./DiscountStats.vue?vue&type=template&id=43eb6f01"
import script from "./DiscountStats.vue?vue&type=script&lang=js"
export * from "./DiscountStats.vue?vue&type=script&lang=js"
import style0 from "./DiscountStats.vue?vue&type=style&index=0&id=43eb6f01&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports